import { useCallback } from 'react';
import { SearchableMultiSelect } from '@/components/ui/SearchableMultiSelect';
import { useSupplierOptions } from '@/hooks/useSupplierOptions';
import { useSupplierSelectSearch } from '@/hooks/useSupplierSelectSearch';
import { useSelectLabels } from '@/hooks/useSelectLabels';

export interface SupplierMultiSelectProps {
  label?: string;
  values?: string[];
  onChange?: (values: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
}

/** Searchable multi-supplier picker — server search by name or code. */
export function SupplierMultiSelect({
  label = 'Suppliers',
  values = [],
  onChange,
  placeholder,
  disabled,
  className,
  required,
  error,
}: SupplierMultiSelectProps) {
  const selectLabels = useSelectLabels();
  const { options, loading, searching, onSearchQuery } = useSupplierSelectSearch({ value: '' });
  const { getLabel } = useSupplierOptions();

  const getOptionLabel = useCallback(
    (value: string) => getLabel(value, true),
    [getLabel],
  );

  return (
    <SearchableMultiSelect
      label={label}
      values={values}
      onChange={onChange}
      options={options}
      placeholder={placeholder ?? selectLabels.selectSuppliers}
      disabled={disabled}
      loading={loading}
      searching={searching}
      className={className}
      required={required}
      error={error}
      filterLocally={false}
      onSearchQuery={onSearchQuery}
      getOptionLabel={getOptionLabel}
      searchPlaceholder={selectLabels.searchSuppliers}
      emptyMessage={selectLabels.noSuppliers}
    />
  );
}
